import {
  Modal as MuiModal,
  Stack,
  Typography
} from "@mui/material";
import {
  alpha,
  styled,
  useTheme
} from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ButtonText
} from "..";
import {
  useAuthStore
} from "../../stores";
import { getEnvironmentVariables } from "../../utils/general";

const StyledModal = styled(MuiModal)(({ theme }) => {
  const contentWidth = "20rem";
  const modalWidth = "25rem";
  const paddingWidth = "2.5rem";
  return {
    backdropFilter:"blur(20px)",
    backgroundColor: theme.linearGradients.gradientB,
    borderRadius:theme.spacing(1),
    boxShadow: "24px",
    height: "fit-content",
    left: "50%",
    maxHeight: "90vh",
    overflow: "auto",
    padding: `1rem ${paddingWidth} 1.5rem 2.5rem`,
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: modalWidth,

    ".MuiModal-backdrop":{
      backdropFilter:"none",
      background:"none",
      borderRadius:theme.spacing(1)
    },

    "p": {
      maxWidth: contentWidth,
      overflowWrap:"break-word"
    }
  };});

export function ImpersonationModal({
  close,
  open=false
} : {
  close: () => void
  open: boolean
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const stopImpersonation = useAuthStore(state => state.stopImpersonation);
  const { adminLink } = getEnvironmentVariables();
  const sessionToken = useAuthStore(state => state.sessionToken);
  const authenticationMode = useAuthStore(state => state.mode);
  const smartConfiguration = useAuthStore(state => state.smartConfiguration);
  const [disableButtons, setDisableButtons] = useState(false);
  const inititiveUrl =  smartConfiguration?.urlDomain
    ? `${smartConfiguration?.urlDomain}.${smartConfiguration.urlCorporateDomain}`
    : smartConfiguration?.urlCorporateDomain
      ?  `${smartConfiguration?.urlCorporateDomain}`
      : window.location.host;

  function deleteCookie(cname: string) {
    document.cookie =
    cname + "=delete;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
  }

  return (
    <StyledModal
      aria-labelledby="modal"
      open={ open }
      onClose={ close }
      slotProps={ {
        backdrop: {
          sx: {
            background: alpha(theme.customColors.backgroundPrimary, 0.95),
            border: `${theme.spacing(0.4)} solid ${theme.customColors.borderPrimaryCta}`,
            boxShadow: `0 0 1rem 0rem ${alpha(theme.customColors.backgroundPrimaryCta, 0.95)},
0 0 2rem 0.25rem ${alpha(theme.customColors.backgroundPrimary, 0.95)}`
          }
        }
      } }
    >
      <Stack
        alignItems="center"
        gap={ 4 }
        sx={ { "&:focus-visible": {
          outline: "none"
        } } }
      >
        <Stack
          alignItems="center"
          gap={ 1 }
        >
          <Typography
            aria-labelledby="modal-modal-title"
            color={ theme.customColors.textPrimary }
            fontSize="2.1rem"
            fontWeight={ 900 }
          >
            { t("end-impersonation-title") }
          </Typography>
          <Typography
            aria-describedby="modal-modal-description"
            color={ theme.customColors.exploreCardText }
            fontSize="1.15rem"
            sx={ { whiteSpace: "pre-line" } }
          >
            { t("end-impersonation-description") }
          </Typography>
        </Stack>
        <Stack
          direction="row"
          gap={ 2 }
        >
          <ButtonText
            variant="outlined"
            onClick={ close }
            disabled={ disableButtons }
            sx={ {
              "&.Mui-disabled": {
                color: theme.customColors.textPrimary,
                opacity: 0.5
              },
              ":hover": { backgroundColor: alpha(theme.customColors.backgroundPrimaryCta, 0.9) }
            } }
          >
            { t("annul") }
          </ButtonText>
          <ButtonText
            onClick={ () => {
              setDisableButtons(true);
              stopImpersonation();
              setTimeout(() => {
                deleteCookie("activeLangCode");
                deleteCookie("isImpersonation");
                localStorage.removeItem("authState");
                // eslint-disable-next-line max-len
                window.location.href = `${adminLink}?sessionId=${sessionToken}&mode=${authenticationMode}&initiativeUrl=${inititiveUrl}`;
              }, 3000);
            } }
            disabled={ disableButtons }
            sx={ {
              "&.Mui-disabled": {
                color: theme.customColors.textPrimaryCta,
                opacity: 0.5
              },
              ":hover": { backgroundColor: alpha(theme.customColors.backgroundPrimaryCta, 0.9) }
            } }
          >
            { t("confirm") }
          </ButtonText>
        </Stack>
      </Stack>
    </StyledModal>
  );
}


